import { createElement, forwardRef, useEffect, useRef, useState, useImperativeHandle } from 'react';
import cx from 'classnames';
import { DatePicker, DatePickerProps } from '../../DatePicker';
import { SliderGripInputRef, SliderGripInputProps } from './SliderGripInputProps';
import { BaseSliderProps } from '../__internal__';
import { TestIdProps } from '../../../util/testId';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';

import cn from './SliderValueGrip.css.json';
import './SliderValueGrip.css';

export const SliderDatePicker = forwardRef<
  SliderGripInputRef,
  SliderGripInputProps &
    TestIdProps & {
      datePickerProps: Omit<DatePickerProps, 'value' | 'onChange' | 'onFocusIn' | 'onFocusOut'>;
      setSliderGripControlIsVisible?: BaseSliderProps['setSliderGripControlIsVisible'];
    }
>(function SliderDatePicker(props, ref) {
  const [isFocused, setIsFocused] = useState(false);

  const refDatePicker = useRef<any>(null);
  useImperativeHandle(ref, () => ({
    focusInput() {
      refDatePicker.current?.focus();
    },
  }));

  const { setSliderGripControlIsVisible } = props;
  const dt = useDesignTokens();
  const tokensStyle = renderInlineCssVars(
    dt.enableNovaTokens ? dt.backgroundsNova.panes : dt.backgrounds.panes,
    'slider-datepicker'
  );

  useEffect(() => {
    if (isFocused) {
      setSliderGripControlIsVisible?.(true);
    } else {
      setSliderGripControlIsVisible?.(false);
    }
  }, [isFocused, setSliderGripControlIsVisible]);

  return (
    <DatePicker
      // FIXME: TS 3.7.5 can't spread unions, works in 4.0 (and maybe 3.9)
      {...(props.datePickerProps as any)}
      testId={props.testId}
      enableResetButton={false}
      ariaLabel={props.ariaLabel}
      ref={refDatePicker}
      className={cx(cn.datepicker, props.datePickerProps.className, !isFocused && cn.offscreen)}
      style={{ ...tokensStyle, ...props.datePickerProps.style }}
      value={new Date(props.value)}
      onChange={(e) => {
        props.onCommit({ value: e.value?.getTime() ?? new Date().getTime() });
      }}
      onCancel={props.onCancel}
      onFocusIn={() => setIsFocused(true)}
      onFocusOut={(isValid) => setIsFocused(isValid === false ? true : false)}
    />
  );
});
